import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "../../i18n";

export function ActionLabel({ labelKey, className = "" }) {
    const { t } = useTranslation();
    const label = t(`delivery.actions.${labelKey}`);

    if (label === `delivery.actions.${labelKey}`) {
        return null;
    }

    return <span className={`delivery-action-label ${className}`.trim()}>{label}</span>;
}

export function DownloadButton({
    onClick,
    labelKey = "download",
    type = "default",
    block = false,
    size = "middle",
    className = "",
}) {
    return (
        <Button
            type={type}
            size={size}
            block={block}
            icon={<DownloadOutlined />}
            onClick={onClick}
            className={`delivery-download-btn ${className}`.trim()}
        >
            <ActionLabel labelKey={labelKey} />
        </Button>
    );
}

export function DownloadIconButton({ onClick, labelKey = "download", className = "" }) {
    const { t } = useTranslation();
    const label = t(`delivery.actions.${labelKey}`);

    return (
        <button
            type="button"
            className={`delivery-download-icon-btn ${className}`.trim()}
            onClick={onClick}
            aria-label={label}
            title={label}
        >
            <DownloadOutlined />
        </button>
    );
}
